import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["filters", "parameters", "dialog", "name"]

  connect() {
    this.beforeCache = () => this.dialogTarget.close()
    document.addEventListener("turbo:before-cache", this.beforeCache)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.beforeCache)
  }

  open() {
    this.dialogTarget.showModal()
    this.nameTarget.focus()
  }

  close() {
    this.dialogTarget.close()
  }

  restoreFocus() {
    this.element.querySelector("button[aria-label^='Saved ']")?.focus()
  }

  backdrop(event) {
    if (event.target !== this.dialogTarget) return
    const rect = this.dialogTarget.getBoundingClientRect()
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close()
  }

  prepareSave() {
    const values = new FormData(this.filtersTarget.querySelector("form"))
    const search = this.element.closest(".card").querySelector("#query_input")
    if (search) values.set("query", search.value)

    const fields = []
    for (const [name, value] of values) {
      if (!["query", "ids", "sort_by", "sort_dir", "status", "tab", "queue", "group_by"].includes(name) && !/^filters\[[^\]]+\]$/.test(name)) continue

      const input = document.createElement("input")
      input.type = "hidden"
      input.name = name
      input.value = value
      fields.push(input)
    }
    this.parametersTarget.replaceChildren(...fields)
  }
}
